import { useEffect, useState } from 'react';
import { adminApi } from '../../adminApi';
import { IconRefresh, IconTrash, IconArchive } from '../../components/Icon';
import { AdminHeader, Reveal } from './ui';

export default function AdminTrash() {
  const [rows,setRows]=useState<any[]>([]);
  const load=()=> adminApi.trash().then(r=>{ if(r.status===200) setRows(r.data?.trash||[]); });
  useEffect(()=>{ load(); },[]);
  return (
    <div>
      <AdminHeader icon={IconArchive} title="Trash" subtitle="Soft-deleted items — restore or purge forever. Covers users, servers, coupons, invoices, alerts, builds, logs." />
      <Reveal className="glass overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="text-xs uppercase tracking-widest text-[color:var(--color-ink-faint)] border-b border-[color:var(--color-line)]"><tr><th className="text-left px-6 py-4">Type</th><th className="text-left px-6">Entity</th><th className="text-left px-6">Deleted</th><th className="text-right px-6">Actions</th></tr></thead>
            <tbody>
              {rows.map((t:any)=><tr key={t.id} className="border-b border-white/5">
                <td className="px-6 py-4"><span className="chip">{t.type}</span></td>
                <td className="px-6 text-xs font-mono">#{t.entity_id}</td>
                <td className="px-6 text-xs text-[color:var(--color-ink-faint)]">{String(t.created_at).slice(0,16)}</td>
                <td className="px-6 text-right"><div className="flex gap-2 justify-end">
                  <button onClick={async()=>{ await adminApi.trashRestore(t.id); load(); }} className="text-xs px-3 py-1 rounded-lg bg-[color:var(--color-ok)]/15 text-[color:var(--color-ok)] border border-[color:var(--color-ok)]/30 inline-flex items-center gap-1"><IconRefresh width={12} height={12}/> Restore</button>
                  <button onClick={async()=>{ if(confirm('Purge forever?')){ await adminApi.trashPurge(t.id); load(); } }} className="text-xs text-red-400 inline-flex items-center gap-1"><IconTrash width={12} height={12}/> Purge</button>
                </div></td>
              </tr>)}
              {rows.length===0 && <tr><td colSpan={4} className="px-6 py-12 text-center text-sm text-[color:var(--color-ink-faint)]">Trash empty — deletions appear here.</td></tr>}
            </tbody>
          </table>
        </div>
      </Reveal>
    </div>
  );
}
